import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'expander',
  templateUrl: './expander-component.html',
})
export class ExpanderComponent {
  private readonly SPACEBAR_KEYCODE = 32;
  private readonly ENTER_KEYCODE = 13;

  private isExpandedValue: boolean;

  @Input()
  public heading: string;

  @Output()
  public isExpandedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  public get isExpanded() {
    return this.isExpandedValue;
  }

  public set isExpanded(value: boolean) {
    this.isExpandedValue = value;
    this.isExpandedChange.emit(this.isExpandedValue);
  }

  constructor() {
    this.isExpanded = true;
  }

  public invertExpansion(): void {
    this.isExpanded = !this.isExpanded;
  }

  public onKeyPress(e: KeyboardEvent): void {
    // Keycode for ENTER should not be required (the button should detect it as 'click' event)
    if (
      e.keyCode === this.SPACEBAR_KEYCODE ||
      e.keyCode === this.ENTER_KEYCODE
    ) {
      e.preventDefault();
      this.invertExpansion();
    }
  }
}
